import { useMemo } from "react";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { X } from "lucide-react";
import { MESES, Sel } from "@/components/fiscal/FiscalFiltros";

export const FAT_VAZIO = { ano: String(new Date().getFullYear()), mes: "", uf: "", curso: "" };

export const cursosDoFiltro = (cursos, f) => cursos.filter((c) =>
  (!f.ano || (c.mes || "").slice(0, 4) === f.ano)
  && (!f.mes || (c.mes || "").slice(5, 7) === String(f.mes).padStart(2, "0"))
  && (!f.uf || c.uf === f.uf));

export function FaturamentoFiltros({ f, setF, cursos }) {
  const set = (k) => (v) => setF((x) => ({ ...x, [k]: v, ...(k !== "curso" ? { curso: "" } : {}) }));
  const anos = useMemo(() => {
    const y = new Date().getFullYear();
    const s = new Set([y + 1, y, y - 1]);
    cursos.forEach((c) => { const a = Number((c.mes || "").slice(0, 4)); if (a) s.add(a); });
    return [...s].sort((a, b) => b - a);
  }, [cursos]);
  const opcoes = cursosDoFiltro(cursos, f);
  // Estados acompanham ano/mês escolhidos (mantém o selecionado na lista)
  const ufs = [...new Set([...cursosDoFiltro(cursos, { ...f, uf: "" }).map((c) => c.uf), f.uf].filter(Boolean))].sort();
  return (
    <Card className="p-4 rounded-2xl">
      <div className="grid grid-cols-2 md:grid-cols-6 gap-2 items-end">
        <Sel label="Ano do curso" value={f.ano} onChange={set("ano")} testid="fat-filtro-ano">
          <option value="">Todos</option>
          {anos.map((a) => <option key={a} value={a}>{a}</option>)}
        </Sel>
        <Sel label="Mês de início do curso" value={f.mes} onChange={set("mes")} testid="fat-filtro-mes">
          <option value="">Todos</option>
          {MESES.map((m, i) => <option key={m} value={i + 1}>{m}</option>)}
        </Sel>
        <Sel label="Estado do curso" value={f.uf} onChange={set("uf")} testid="fat-filtro-uf">
          <option value="">Todos</option>
          {ufs.map((u) => <option key={u} value={u}>{u}</option>)}
        </Sel>
        <Sel label={`Curso (${opcoes.length})`} value={f.curso} onChange={set("curso")} testid="fat-filtro-curso" className="col-span-2">
          <option value="">Todos</option>
          {opcoes.map((c) => <option key={c.id} value={c.id}>{c.rotulo}</option>)}
        </Sel>
        <Button variant="outline" onClick={() => setF(FAT_VAZIO)} className="h-9" data-testid="fat-limpar">
          <X className="w-4 h-4 mr-1" /> Limpar
        </Button>
      </div>
    </Card>
  );
}
